import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

import Component from '../../components/component/component';
import Helpers from '../../components/helpers/helpers';

import './testimonials.scss';

export default class Testimonials extends Component {
    static initSelector: string = '.testimonials';

    constructor(element: HTMLElement) {
        super(element);

        this.init();
    }

    init(): void {
        const slider: Splide = new Splide(
            this.element.find('.testimonials__slider').get(0),
            {
                type: 'loop',
                drag: false,
                focus: 'center',
                perPage: 1,
                autoScroll: {
                    speed: .5,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    rewind: false,
                },
                gap: '40px',
                arrows: false,
                pagination: false,
                clones: 5,
                breakpoints: {
                    [Helpers.breakPoints.sm]: {
                        gap: '16px',
                    },
                },
            },
        );

        slider.mount({AutoScroll});
    }

}
